/**
 * Minimal ADF-like node shape needed for recursive node type searches.
 */
export interface AdfNodeWithContent {
  /** ADF node type name. */
  type: string;
  /** Child ADF nodes, when this node can contain children. */
  content?: readonly AdfNodeWithContent[];
}

/**
 * Returns whether an ADF subtree contains a node with the requested type.
 *
 * @param node - Root node to search.
 * @param typeName - ADF node type to find.
 * @returns `true` when the root or one of its descendants has the requested type.
 */
export const containsNodeType = (node: AdfNodeWithContent, typeName: string): boolean => {
  if (node.type === typeName) {
    return true;
  }

  return node.content?.some((child) => containsNodeType(child, typeName)) ?? false;
};
